export class UserConstants {
    public static readonly DEFAULT_AVATAR_URL = "/img/user.png";
}